import { render, staticRenderFns } from "./warningQuery.vue?vue&type=template&id=154ddc2a&scoped=true"
import script from "./warningQuery.js?vue&type=script&lang=js&external"
export * from "./warningQuery.js?vue&type=script&lang=js&external"
import style0 from "./warningQuery.scss?vue&type=style&index=0&id=154ddc2a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ddc2a",
  null
  
)

export default component.exports